import { IController, IWindowService, ui } from 'angular';
import * as _ from 'lodash';
import { ImSchool } from 'Src/ng2/shared/services/im-models/im-school';

import { GraduationPlanTransfer } from '../../../../../../ng2/shared/constants/graduation-plan-transfer.constant';
// tslint:disable-next-line:max-line-length
import { StudentListPreviewModal } from './../../../../../shared/modals/student-list-preview/student-list-preview.service';
import { ISdcStore } from './../../../../flux/sdc-store.interface';

export class GradPlanningTransferTableCtrl implements IController {
  static inject: string[] = [
    'ObjectCache',
    '$scope',
    'SDCStore',
    'ImSchool',
    'StudentListPreviewModal',
    '$state',
    '$window',
  ];

  // class properties
  public currentCohortFilter;
  public nextFourGradTerms;
  public school;
  public filteredStudents;
  public termsObject;
  public nonTermObject;
  public tableData;
  public dashPlaceholders;
  public totalsRow;
  public options;

  constructor(
    private ObjectCache: any,
    private $scope,
    private SDCStore: ISdcStore,
    private ImSchool: ImSchool,
    public StudentListPreviewModal: StudentListPreviewModal,
    private $state: ui.IStateService,
    private $window: IWindowService,
  ) {
    this.options = {
      columnKeys: ['gradPlan', 'plannedDiplomaType', 'plannedGraduationDate'],
      sort: {
        colId: 'plannedDiplomaType',
        direction: 'desc',
      },
    };
  }

  $onInit(): void {
    this.$scope.$listenTo(this.SDCStore, ['ui', 'isLoading'], () => {
      const isLoading = this.SDCStore.getUiState().isLoading;
      if (!isLoading) {
        this.setUi();
        this.setListeners();
      }
    });
  }

  private setListeners() {
    this.$scope.$listenTo(this.SDCStore, ['school'], this.setUi.bind(this));
    this.$scope.$listenTo(this.SDCStore, ['filteredFlattenedStudents'], this.setUi.bind(this));
    this.$scope.$listenTo(this.SDCStore, ['filter'], this.setUi.bind(this));
    this.$scope.$listenTo(this.SDCStore, ['flattenedStudents'], this.setUi.bind(this));
  }

  private setUi(): void {
    this.school = this.SDCStore.getSchool();
    this.dashPlaceholders = new Array(5);
    this.filteredStudents = this.SDCStore.getFilteredFlattenedStudents();
    this.currentCohortFilter = _.last(this.SDCStore.getFilter().cohort);
    this.nextFourGradTerms = this.ImSchool.getNextFourGradDatesForTransfer();

    // genrate objects for table creation
    this.termsObject = this.generateTermObject();
    this.nonTermObject = {
      'Plan in Past': { total: [] },
      'Plan Incomplete': { total: [] },
      'Non-Graduate': { total: [] },
      'Negative Discharge': { total: [] },
      Graduate: { total: [] },
      'Future Date': { total: [] },
    };
    this.tableData = this.buildTable();
    this.totalsRow = this.buildTotalsRow();
  }

  private generateTermObject(): object {
    const baseObj = { Local: { total: [] }, Regents: { total: [] }, 'Advanced Regents': { total: [] } };
    const multiTermObj = _.reduce(
      this.nextFourGradTerms,
      (result: any, term: any) => {
        baseObj.Local[term.humanName] = [];
        baseObj.Regents[term.humanName] = [];
        baseObj['Advanced Regents'][term.humanName] = [];
        return baseObj;
      },
      baseObj,
    );
    // append future date key to each diploma type
    multiTermObj.Regents['Future Date'] = [];
    multiTermObj.Local['Future Date'] = [];
    multiTermObj['Advanced Regents']['Future Date'] = [];

    return multiTermObj;
  }

  private buildTable(): object {
    const baseObj = _.merge(this.nonTermObject, this.termsObject);
    const tableData = _.reduce(
      this.filteredStudents,
      (result: any, student: any) => {
        const { studentId, gradPlan } = student;
        const gradPlanDetails = _.find(GraduationPlanTransfer, { humanName: gradPlan });
        if (!gradPlanDetails) return baseObj;
        // if regents or local, use nested logic
        if (gradPlanDetails.diploma) {
          if (!baseObj[gradPlanDetails.diploma][gradPlanDetails.date]) {
            baseObj[gradPlanDetails.diploma]['Future Date'].push(studentId);
          } else if (baseObj[gradPlanDetails.diploma][gradPlanDetails.date]) {
            baseObj[gradPlanDetails.diploma][gradPlanDetails.date].push(studentId);
          }
        } else if (gradPlanDetails.humanName === 'Plan in Past') {
          baseObj['Plan Incomplete'].total.push(studentId);
        } else {
          baseObj[gradPlanDetails.humanName].total.push(studentId);
        }
        return baseObj;
      },
      baseObj,
    );

    // this method mutates tableData
    this.sumAndAppendRowTotals(tableData);
    return tableData;
  }

  // sum students for local, regents and advanced regents
  private sumAndAppendRowTotals(tableData: object): void {
    _.forOwn(tableData, (collection, diploma) => {
      if (!_.isArray(collection)) {
        _.forOwn(collection, (studentIds, gradDate) => {
          if (gradDate === 'total') return;
          collection.total = collection.total.concat(studentIds);
        });
      }
    });
  }

  // total row:
  private buildTotalsRow(): object {
    const columnHeaders: any = _.reduce(
      this.nextFourGradTerms,
      (result: any, term: any) => {
        result[term.humanName] = [];
        return result;
      },
      { total: [] },
    );
    columnHeaders['Future Date'] = [];
    _.forOwn(this.tableData, (collection, diploma) => {
      _.forOwn(collection, (studentIds, gradDate) => {
        columnHeaders[gradDate] = columnHeaders[gradDate].concat(studentIds);
      });
    });
    return columnHeaders;
  }
}
